import { useIntl } from "react-intl";
import {
  Button,
  type ButtonProps,
} from "src/design-system/components/Button/Button";
import Search from "src/design-system/icons/Search.svg?react";
import messages from "src/domain/LargeSearchBar/LargeSearchBar.messages.ts";
import Check from "src/design-system/icons/Check.svg?react";
import { forwardRef, useEffect, useState, type ForwardedRef } from "react";
import { tw } from "src/design-system/tw";
import { Icon } from "src/design-system/components/Icon/Icon";

function SearchButtonInner(
  {
    hidePulse,
    ...props
  }: ButtonProps & {
    hidePulse?: boolean;
  },
  ref: ForwardedRef<HTMLButtonElement>,
) {
  const intl = useIntl();
  const [showTick, setShowTick] = useState(false);
  const { isDisabled, className } = props;

  useEffect(() => {
    if (showTick) {
      const timer = setTimeout(() => {
        setShowTick(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [showTick]);

  return (
    <Button
      size="large"
      className={tw(
        "relative m-1 h-10 w-10 rounded-full",
        typeof className === "string" && className,
      )}
      ref={ref}
      {...props}
      onPress={(e) => {
        props.onPress?.(e);
        setShowTick(true);
      }}
    >
      <span className="sr-only">
        {intl.formatMessage(messages.searchLabel)}
      </span>
      {!isDisabled && !hidePulse && (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute top-1/2 left-1/2 h-3/4 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-fill-brand opacity-75 motion-safe:animate-ping"
        ></span>
      )}
      <Icon>
        {(!showTick || !isDisabled) && <Search />}
        {showTick && isDisabled && <Check />}
      </Icon>
    </Button>
  );
}
export const SearchButton = forwardRef(SearchButtonInner);
SearchButton.displayName = "SearchButton";
